import store from '../redux/store';

export function getStoreType(storeInfo = null) {
  const storeData = storeInfo || store.getState().storeReducer.store;
  return storeData?.services?.store_type_flag;
}
